import Swiper, {Navigation, Lazy, Keyboard, A11y, EffectCoverflow} from 'swiper';

Swiper.use([Navigation, Lazy, Keyboard, A11y, EffectCoverflow]);

const initSliders = () => {

    if (document.querySelectorAll('.ume-respekt-staff-portraits-container').length > 0) {

        const gallery = document.querySelector('.ume-respekt-staff-portraits-container');


        const swiperContainer = gallery.querySelector('.swiper-container');
        const newSlider = new Swiper(swiperContainer, {
            direction: 'horizontal',
            grabCursor: 'true',
            speed: 600,
            loop: true,
            lazy: true,
            updateOnWindowResize: true,
            preloadImages: false,
            coverflowEffect: {
                depth: 100,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            a11y: {
                prevSlideMessage: 'Zurück',
                nextSlideMessage: 'Weiter'
            },
            centeredSlides: true,
            watchSlidesVisibility: true,
            breakpoints: {
                1649: {
                    slidesPerView: 1.7,
                    spaceBetween: 20,
                },
                1467: {
                    slidesPerView: 1.5,
                    spaceBetween: 15,
                },
                1267: {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                },
                1201: {
                    slidesPerView: 1.1,
                    spaceBetween: 5,
                },
                1023: {
                    slidesPerView: 1,
                    spaceBetween: 5,
                },
                769: {
                    slidesPerView: 1.5,
                    spaceBetween: 15,
                },
                569: {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                },

            },
            slidesPerView: 1,
            spaceBetween: 5,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: () => {

                    const activeSlides = gallery.querySelectorAll('.swiper-slide-visible');

                }
            }
        });


    }
}

export default initSliders;